import { ThemeProvider } from 'styled-components';

import { Loader, palette } from '@/js/libs/ui';

import 'src/api';
import { Notification } from 'src/modules/Notification';
import { ThemeControllerProvider, useThemeController } from 'src/theme/ThemeController';
import { AppRouter } from './AppRouter';
import { AppSuspense } from './components/AppSuspense';

const ThemedApp = () => {
  const { themeId } = useThemeController();
  return (
    <ThemeProvider theme={palette[themeId]}>
      <Notification />
      <AppSuspense fallback={<Loader type='initial' />}>
        <AppRouter fallback={<Loader />} />
      </AppSuspense>
    </ThemeProvider>
  );
};

export const App = () => (
  <ThemeControllerProvider>
    <ThemedApp />
  </ThemeControllerProvider>
);
